import React from 'react';
import classNames from 'classnames';
import Tooltip from '../ToolTip/ToolTip';

import css from './DisabledCtaWithTooltip.module.css';

const DisabledCtaWithTooltip = props => {
  const { tooltipContent, children, className, placement = 'top' } = props;

  if (!tooltipContent) {
    return children;
  }

  return (
    <Tooltip content={tooltipContent} mode="dark" placement={placement}>
      <span className={classNames(css.wrapper, className)}>{children}</span>
    </Tooltip>
  );
};

export default DisabledCtaWithTooltip;
